export default "__VITE_PUBLIC_ASSET__9a7210aa__"